var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"text-primary",on:{"click":function($event){return _vm.goToDetail()}}},[_vm._v(" "+_vm._s(_vm.params.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }